var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import React from 'react';
import styled from 'styled-components';
import helpIcon from '../../images/help.svg';
import { HelpIconDialog } from './HelpIconDialog';
var HelpIcon = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  font-size: 0.8rem;\n\n  .installment-payments-help-icon {\n    cursor: pointer;\n    width: 12px;\n  }\n"], ["\n  font-size: 0.8rem;\n\n  .installment-payments-help-icon {\n    cursor: pointer;\n    width: 12px;\n  }\n"])));
export var HelpWithDialogIcon = function (_a) {
    var title = _a.title, description = _a.description;
    var _b = React.useState(false), confirmDialogOpen = _b[0], setConfirmDialogOpen = _b[1];
    var handleClickHelp = function () {
        setConfirmDialogOpen(true);
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(HelpIcon, null,
            React.createElement("img", { className: "installment-payments-help-icon", src: helpIcon, onClick: handleClickHelp })),
        React.createElement(HelpIconDialog, { open: confirmDialogOpen, onClose: function () { return setConfirmDialogOpen(false); }, title: title, description: description })));
};
var templateObject_1;
